export const rule: any = [
  {
    label: '作品名称*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入作品名称',
    title: '',
    value: 'name',
    max: 20,
  },
  {
    label: '作品组别*',
    require: true,
    type: 'picker',
    columns: [
      '绘画小学组',
      '绘画中学组',
      '海报',
    ],
    placeholder: '请选择组别',
    title: '组别',
    value: 'work_type',
  },
  {
    label: '作者姓名*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入姓名',
    title: '',
    value: 'author_name',
    max: 6,
  },
  {
    label: '联系方式*',
    require: true,
    type: 'input',
    columns: [],
    placeholder: '请输入联系人电话',
    title: '',
    value: 'phone',
    reg: /^1[3-9][0-9]{9}$/,
  },
  {
    label: '学校名称',
    require: false,
    type: 'input',
    columns: [],
    placeholder: '请输入学校名称',
    title: '',
    value: 'sch_name',
    max: 6,
  },
  {
    label: '指导老师',
    require: false,
    type: 'input',
    columns: [],
    placeholder: '请输入指导老师',
    title: '',
    value: 'teacher_name',
    max: 6,
  },
  {
    label: '作品简介*',
    require: true,
    type: 'textarea',
    columns: [],
    placeholder: '请输入作品简介',
    title: '',
    value: 'introduction',
    max: 800,
  },
  {
    label: '上传作品图片*',
    require: true,
    type: 'cover',
    columns: [],
    placeholder: '上传作品图片',
    title: '',
    value: 'cover',
  },
];
export const field: any = {
  name: '',
  work_type: '',
  author_name: '',
  phone: '',
  sch_name: '',
  teacher_name: '',
  introduction: '',
  cover: [],
};
